/** Veneer classifications shared with the API. */
export const VeneerType = {
  NoPrepVeneer: 1,
  PrepVeneer: 2,
  Sample: 3,
} as const;

export type VeneerType = (typeof VeneerType)[keyof typeof VeneerType];
